import { InjectionToken } from '@angular/core';

export interface ErrorLogger {
	error?: (...args: any[]) => void;
	warn?: (...args: any[]) => void;
}

export const ERROR_LOGGER = new InjectionToken<ErrorLogger>('Error Logger Token');
